import React, { useEffect, useRef, useState, useCallback } from 'react';
import styles from "./style.module.scss"
import { Select, notification, Button, Input, Checkbox, Card, Drawer, Table, Spin, Tag, message, Tabs } from 'antd';
import SortPopup from 'helperComponents/SortPopup';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { SET_USER } from "redux/user/actions.js";
import { apiRequest } from "util/services";
import { hasCustomerJourneyPlan } from "util/customerJourneyAccess";
import {
  trackAddonLockCtaClicked,
  trackAddonLockViewed,
} from "util/productAnalytics";
import { themeColor, themeLayoutColor } from "util/common";
import { Spin as AntdSpin } from "antd";
import { HorizontalChart, BarChart, BarChartFeedback , ChartDemo} from "./journeyChart"
import DateFilterPopUp from "../../components/Dashboard/DateFilter/index";
import dayjs from 'dayjs'
import relativeTime from "dayjs/plugin/relativeTime"
import { SearchOutlined, BarChartOutlined, DownOutlined, CloseOutlined, ArrowUpOutlined, EyeOutlined, NodeIndexOutlined, MailOutlined, LinkOutlined, SettingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import JourneySettings from './JourneySettings';
import WelcomeDrawerReviewsList from 'pages/Welcome/WelcomeDrawerReviewsList';
import { extractWelcomeReviewsFromApiResponse } from 'pages/Welcome/welcomeDrawerReviewDoc';
dayjs.extend(relativeTime)

const { Search } = Input;



const CUSTOMER_JOURNEY_PRODUCT_URL =
    "https://pivony.com/customer-journey";

const CustomerJourney = ({ authenticated, user }) => {
    const theme = useSelector((state) => state.DashboardReducer.theme);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const subscriptionStatus = useSelector((state) => state.userReducer);
    const [subscriptionFetchFinished, setSubscriptionFetchFinished] = useState(false);
    const subscriptionHydrated =
        subscriptionStatus?.PackageId != null ||
        subscriptionStatus?.PackageName != null ||
        subscriptionFetchFinished;
    const canAccessCustomerJourney = hasCustomerJourneyPlan(subscriptionStatus);

    useEffect(() => {
        if (
            authenticated === "logged" &&
            subscriptionHydrated &&
            !canAccessCustomerJourney
        ) {
            trackAddonLockViewed("customer_journey");
        }
    }, [authenticated, subscriptionHydrated, canAccessCustomerJourney]);

    const [showSearchBox, setShowSearchBox] = useState(false);
    const [showRowItems, setShowRowItems] = useState(true);
    const [showSortPopup, setShowSortPopup] = useState(false);
    const [sortValue, setSortValue] = useState()
    const [surveyList, setsurveyList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [loading, setLoading] = useState(false)
    const [surveyType, setSurveyType] = useState("All")
    const [searchWord, setSearchWord] = useState("");
    const [totalSurveys, settotalSurveys] = useState()
    const [dashboards, setDashboards] = useState([])
    const [surveryPageNumber, setsurveryPageNumber] = useState(1)
    const [startIndex, setStartIndex] = useState(0);
    const [selectedPerPage, setSelectedPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [surveyTypes, setSurveyTypes] = useState([]);
    const [selectedDashboards, setSelectedDashboards] = useState([])
    const [preSelectedDashboards, setPreSelected] = useState([])
    const [chartData, setChartData] = useState({})
    
    // Side panel state
    const [sidePanelOpen, setSidePanelOpen] = useState(false);
    const [selectedBarData, setSelectedBarData] = useState(null);
    const [topProblems, setTopProblems] = useState([]);
    const [selectedProblem, setSelectedProblem] = useState(null);
    const [problemReviews, setProblemReviews] = useState([]);
    const [reviewsLoading, setReviewsLoading] = useState(false);
    const [topProblemsLoading, setTopProblemsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [problemsPerPage] = useState(5);
    const [currentStepId, setCurrentStepId] = useState(1);
    const [totalReviews, setTotalReviews] = useState(0);
    const [sidePanelTab, setSidePanelTab] = useState("insights");
    

    const [showSourcePicker, setShowPicker] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");
    // Whether the journey lifecycle/stage/step + topic mapping has ever been set up.
    // null = unknown (still checking), false = show wizard, true = show chart + Edit.
    const [cjConfigured, setCjConfigured] = useState(null);
    const [showSettings, setShowSettings] = useState(false);
    const [isInitializing, setIsInitializing] = useState(true);
    const [loadingDashboards, setLoadingDashboards] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const isMounted = useRef(false);
    const isFetching = useRef(false);
    const reviewsRequestIdRef = useRef(0);


    // Initialize empty problems array - will be populated when bar is clicked
    useEffect(() => {
        setTopProblems([]);
    }, []);

    useEffect(() => {
        setSubscriptionFetchFinished(false);
    }, [user?.uid]);

    // Hydrate subscription info (PackageId / PackageName) if it is not already in redux,
    // so we can decide whether the user owns the Customer Journey add-on (PackageId 110).
    useEffect(() => {
        if (authenticated !== "logged") return;
        const hasRow =
            subscriptionStatus?.PackageId != null ||
            subscriptionStatus?.PackageName != null;
        if (hasRow || !user?.uid) return;

        let cancelled = false;
        apiRequest(
            "subscriptions/all",
            "POST",
            { user_id: user.uid },
            true
        ).then((result) => {
            if (cancelled) return;
            setSubscriptionFetchFinished(true);
            if (!result?.error && result?.[0]) {
                dispatch({ type: SET_USER, payload: result[0] });
            }
        });
        return () => {
            cancelled = true;
        };
    }, [
        authenticated,
        user?.uid,
        subscriptionStatus?.PackageId,
        subscriptionStatus?.PackageName,
        dispatch,
    ]);

    useEffect(() => {
        if (!canAccessCustomerJourney) return;
        checkSetupStatus()
        getSelectedDashboards()
        getDashboards() // Fetch available dashboards
    }, [canAccessCustomerJourney])

    // Determine whether the org has already mapped topics onto a journey structure.
    // Drives the wizard-vs-chart decision.
    const checkSetupStatus = async () => {
        try {
            const res = await apiRequest("users/cj/setup/status", "POST", {}, true);
            const status = res?.success;
            setCjConfigured(!!(status && status.has_steps && status.has_mappings));
        } catch (error) {
            console.error("Error checking CJ setup status:", error);
            setCjConfigured(false);
        }
    }

    // Persist the selected data-source dashboards for the journey.
    const persistSources = async (ids) => {
        try {
            await apiRequest(
                "users/cj/source/add",
                "POST",
                { dashboard_ids: ids || [] },
                true
            );
        } catch (error) {
            console.error("Error saving CJ sources:", error);
        }
    }

    // Called after the wizard/edit panel saves the structure.
    const handleSettingsSaved = async () => {
        setShowSettings(false);
        setShowPicker(false);
        await checkSetupStatus();
        fetchChartData();
    }

    const handleWizardDashboardsChange = (ids) => {
        setSelectedDashboards(ids);
        persistSources(ids);
    }

    const getDashboards = async () => {
        setLoadingDashboards(true);
        try {
            const response = await apiRequest("library/dashboards", "POST", true);
            if (response.success && Array.isArray(response.success)) {
                setDashboards(response.success);
            } else {
                notification.error({
                    message: response.error || "Failed to fetch dashboards or invalid data format",
                });
            }
        } catch (error) {
            notification.error({
                message: "Error fetching dashboards",
            });
        }
        setLoadingDashboards(false);
    };

    const getSelectedDashboards = async () => {
        try {
        const result = await apiRequest(
            "users/cj/source",
            "POST",
            {

            },
            true
        );
        if (!result.error) {
            let dashboardsSelected = []
            if (result?.success?.length) {
                result.success.map((info) => {
                    if (info.status === 1) {
                        dashboardsSelected.push(info.id)
                    }
                })
            }
            setDashboards(result.success)
            if (dashboardsSelected.length) {
                setShowPicker(false)
                setSelectedDashboards(dashboardsSelected)
                setDateRange([dayjs().add(-24, 'h'), dayjs()])
                // Chart data will be fetched automatically by useEffect when selectedDashboards and dateRange are set
            } else {
                setShowPicker(true)
            }
            }
        } catch (error) {
            console.error('Error fetching dashboards:', error);
            // Default to showing source picker if there's an error
            setShowPicker(true);
        } finally {
            setIsInitializing(false);
        }
    }

    const handlePageChange = () => {
        let end_index = surveyList.length
        if (isMounted.current) {
            if (selectedPerPage * surveryPageNumber < end_index) {
                end_index = selectedPerPage * surveryPageNumber;
                setHasNextPage(true)
            } else {
                setHasNextPage(false)
            }
        } else {
            isMounted.current = true
        }
        if (surveyList.length == 0) {
            let temp = []
            setFilteredList(temp)
        } else {
            let temp = surveyList?.slice(startIndex * selectedPerPage, end_index)
            setFilteredList(temp)
        }
    }

    useEffect(() => {
        handlePageChange()
    }, [surveryPageNumber])

    useEffect(() => {
        setStartIndex(0);
        let list = surveyList
        let temp = list?.length ? list?.slice(0, selectedPerPage > surveyList.length ? surveyList.length : selectedPerPage) : []
        setFilteredList(temp)
        settotalSurveys(surveyList?.length ? surveyList.length : 0)
    }, [surveyList])

    const saveSelects = async (removedItem) => {
        if (isSaving) return; // Prevent multiple calls
        
        setIsSaving(true);
        try {
            let dashboard_ids = []
            if (selectedDashboards.length) {
                selectedDashboards.map((info) => {
                    if (info) {
                        dashboard_ids.push(info)
                    }
                })
            }
            if (removedItem) {
                dashboard_ids = dashboard_ids.filter((item) => item !== removedItem)
            }
            const result = await apiRequest(
                "users/cj/source/add",
                "POST",
                {
                    dashboard_ids: dashboard_ids
                },
                true
            );
            if (!result.error) {
                notification.success({
                    message: t("common.success"),
                    description: t("common.updated")
                });
                // Chart data will be refreshed automatically by useEffect when selectedDashboards changes
            }
        } catch (error) {
            console.error('Error saving dashboards:', error);
            notification.error({
                message: "Error",
                description: "Failed to save dashboard selection"
            });
        } finally {
            setIsSaving(false);
        }
    }

    const handleShowSearch = () => {
        if (window.innerWidth < 880) {
            setShowRowItems(false);
        }
        setShowSearchBox(!showSearchBox);
    }

    const handleSearch = (event) => {
        if (event.key === 'Enter') {
            if (searchWord.trim()) {
                let list = surveyList.filter((item) => {
                    if (item.survey_name.search(searchWord) !== -1) {
                        return true
                    } else return false
                })
                setFilteredList(list)
            } else {
                setFilteredList(surveyList)
            }
        }
    }

    // Fetch top problems from API
    const fetchTopProblems = async (barData) => {
        setTopProblemsLoading(true);
        try {
            // Use step_id from barData if available, otherwise use currentStepId, or default to 1
            const stepId = barData?.step_id || currentStepId || 1;
            
            console.log('Fetching top problems with step_id:', stepId, 'and barData:', barData);
            
            const result = await apiRequest(
                "users/step_ai_insights",
                "POST",
                {
                    // Pass relevant data from barData to filter problems
                    step_id: stepId,
                    brand: barData?.brand,
                    industry: barData?.industry,
                    category: barData?.category,
                    // You can add more filters based on your API requirements
                },
                true
            );
            
            if (!result.error && result.success) {
                setTopProblems(result?.success?.data);
            } else {
                console.error('API error:', result.error);
                notification.error({
                    message: "Error",
                    description: result.error || "Failed to fetch top problems"
                });
            }
        } catch (error) {
            console.error('Error fetching top problems:', error);
            notification.error({
                message: "Error",
                description: "Failed to fetch top problems. Please try again."
            });
        } finally {
            setTopProblemsLoading(false);
        }
    };

    // Handle bar click to open side panel
    const handleBarClick = (barData) => {
        console.log('Bar clicked with data:', barData);
        setSelectedBarData(barData);
        setSidePanelOpen(true);
        setSelectedProblem(null);
        setProblemReviews([]);
        setTotalReviews(0);
        setCurrentPage(1);
        setSidePanelTab("insights");
        
        // Fetch top problems and all step reviews (Reviews tab without RC selection)
        fetchTopProblems(barData);
        fetchStepReviews(barData);
    };

    const parseReviewsResponse = (result, dashIdFallback = null) => {
        const reviewsData = extractWelcomeReviewsFromApiResponse(result).map((review) => ({
            ...review,
            dash_id:
                review.dash_id ??
                review.dashId ??
                (Number.isFinite(Number(dashIdFallback))
                    ? Number(dashIdFallback)
                    : null),
        }));
        return { reviewsData, totalCount: reviewsData.length };
    };

    // All reviews for the clicked step (no root-cause filter)
    const fetchStepReviews = async (barData) => {
        const requestId = ++reviewsRequestIdRef.current;
        setReviewsLoading(true);
        try {
            const stepId = barData?.step_id || currentStepId || 1;
            const result = await apiRequest(
                "users/cj/step/reviews",
                "POST",
                { step_id: stepId, num_docs: 100 },
                true
            );

            if (requestId !== reviewsRequestIdRef.current) return;

            if (!result.error && result.success) {
                const { reviewsData, totalCount } = parseReviewsResponse(result);
                setProblemReviews(reviewsData);
                setTotalReviews(totalCount);
            } else {
                console.error('Step reviews API error:', result.error);
                setProblemReviews([]);
                setTotalReviews(0);
            }
        } catch (error) {
            if (requestId !== reviewsRequestIdRef.current) return;
            console.error('Error fetching step reviews:', error);
            setProblemReviews([]);
            setTotalReviews(0);
        } finally {
            if (requestId === reviewsRequestIdRef.current) {
                setReviewsLoading(false);
            }
        }
    };

    // Fetch reviews for a specific problem
    const fetchProblemReviews = async (problem) => {
        const requestId = ++reviewsRequestIdRef.current;
        setSelectedProblem(problem); // Set selected problem for row highlighting
        setSidePanelTab("reviews");
        setReviewsLoading(true);
        try {
            console.log('Fetching reviews for problem:', problem);
            
            // Validate required problem data
            if (!problem || (!problem.rc_id && !problem.id)) {
                throw new Error('Invalid problem data: missing rc_id or id');
            }
            
            const result = await apiRequest(
                "dashboards/root-cause/reviews",
                "POST",
                {
                    rc_id: problem.rc_id || problem.id,
                    topic_id: problem.topic_id || null,
                    dash_id: problem.dash_id || null,
                },
                true
            );
            
            if (requestId !== reviewsRequestIdRef.current) return;

            console.log('Reviews API response received:', result);
            
            if (!result.error && result.success) {
                const { reviewsData, totalCount } = parseReviewsResponse(
                    result,
                    problem.dash_id || problem.Dash_ID || null
                );
                console.log('Reviews data:', reviewsData.length, 'Total count:', totalCount);
                
                setProblemReviews(reviewsData);
                setTotalReviews(totalCount);
            } else {
                console.error('Reviews API error:', result.error);
                notification.error({
                    message: "Error",
                    description: result.error || "Failed to fetch reviews"
                });
                setTotalReviews(0);
                setProblemReviews([]);
            }
        } catch (error) {
            if (requestId !== reviewsRequestIdRef.current) return;
            console.error('Error fetching problem reviews:', error);
            notification.error({
                message: "Error",
                description: "Failed to fetch reviews. Please try again."
            });
            setTotalReviews(0);
            setProblemReviews([]);
        } finally {
            if (requestId === reviewsRequestIdRef.current) {
                setReviewsLoading(false);
            }
        }
    };

    // Handle problem click to show reviews
    const handleProblemClick = (problem) => {
        setSelectedProblem(problem);
        setProblemReviews([]); // Clear previous reviews
        
        // Fetch reviews from API
        fetchProblemReviews(problem);
    };

    const handleSidePanelTabChange = (key) => {
        setSidePanelTab(key);
        // Switching to Reviews without a root cause → show all step reviews
        if (key === "reviews" && !selectedProblem && selectedBarData) {
            fetchStepReviews(selectedBarData);
        }
    };


    // Close side panel
    const handleCloseSidePanel = () => {
        setSidePanelOpen(false);
        setSelectedBarData(null);
        setSelectedProblem(null);
        setProblemReviews([]);
        setTotalReviews(0);
        setCurrentPage(1);
        setSidePanelTab("insights");
    };

    // Pagination handlers
    const handleProblemsPageChange = (page) => {
        setCurrentPage(page);
    };

    // Get current page problems
    const getCurrentPageProblems = () => {
        const startIndex = (currentPage - 1) * problemsPerPage;
        const endIndex = startIndex + problemsPerPage;
        return topProblems.slice(startIndex, endIndex);
    };

    // Get total pages
    const getTotalPages = () => {
        return Math.ceil(topProblems.length / problemsPerPage);
    };

    const [showDateFilterPopup, setShowDateFilterPopup] = useState(false)
    const [dateRange, setDateRange] = useState([dayjs().add(-24, 'h'), dayjs()])
    const [selectedDaysRange, setSelectedDaysRange] = useState("last24")
    const rangePresets = {
        last24: {
            label: "Last 24 hours"
        },
        last7d: {
            label: "Last 7 Days"
        },
        last14d: {
            label: "Last 14 Days "
        },
        last30d: {
            label: "Last 30 Days "
        },
        last90d: {
            label: "Last 90 Days"
        },
        custom: {
            label: "Custom"
        },
        allTime: {
            label: "All Time"
        }
    }
    const dateFilterRef = useRef()

    const fetchChartData = async (removedItem) => {
        if (isFetching.current) {
            return;
        }
        
        isFetching.current = true;
        setLoading(true);
        try {
            let dashboard_ids = []
            if (selectedDashboards.length) {
                selectedDashboards.map((info) => {
                    dashboard_ids.push(info)
                })
            }
            if (removedItem) {
                dashboard_ids = dashboard_ids.filter((item) => item !== removedItem)
            }
            
            // Handle all time filter (empty dateRange array) or date range filter
            if (dateRange && dateRange.length === 2) {
                // Ensure we have valid dayjs objects before formatting
                const startDate = dateRange[0] && (typeof dateRange[0].format === 'function') 
                    ? dateRange[0].format('YYYY-MM-DD') 
                    : (dateRange[0] ? dayjs(dateRange[0]).format('YYYY-MM-DD') : "");
                const endDate = dateRange[1] && (typeof dateRange[1].format === 'function') 
                    ? dateRange[1].format('YYYY-MM-DD') 
                    : (dateRange[1] ? dayjs(dateRange[1]).format('YYYY-MM-DD') : "");
                
                const result = await apiRequest(
                    "users/topicJourneyMapping",
                    "POST",
                    {
                        start_date: startDate,
                        end_date: endDate,
                        dashboard_ids: dashboard_ids
                    },
                    true
                );
                if (!result.error) {
                    console.log('Chart data received:', result);
                    setChartData(result);
                    
                    // Extract step_id from the API response if available
                    if (result.success && result.success.step_id) {
                        console.log('Step ID from API response:', result.success.step_id);
                        setCurrentStepId(result.success.step_id);
                    }
                } else {
                    console.log('API error:', result.error);
                }
            } else {
                // All time filter or no date range - call API without date parameters
                const result = await apiRequest(
                    "users/topicJourneyMapping",
                    "POST",
                    {
                        dashboard_ids: dashboard_ids
                    },
                    true
                );
                if (!result.error) {
                    console.log('Chart data received (all time):', result);
                    setChartData(result);
                    
                    // Extract step_id from the API response if available
                    if (result.success && result.success.step_id) {
                        console.log('Step ID from API response:', result.success.step_id);
                        setCurrentStepId(result.success.step_id);
                    }
                } else {
                    console.log('API error:', result.error);
                }
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
            notification.error({
                message: t("common.error"),
                description: t("common.general_error")
            });
        } finally {
            setLoading(false);
            isFetching.current = false;
        }
    }

    useEffect(() => {
        if (!canAccessCustomerJourney) return;
        // Only fetch if we have selectedDashboards and not in source picker mode
        if (selectedDashboards.length === 0 || showSourcePicker) {
            return;
        }

        // For all time filter, dateRange will be empty array, which is valid
        // For other filters, ensure we have valid dateRange array with 2 elements
        if (Array.isArray(dateRange) && dateRange.length > 0 && dateRange.length !== 2) {
            return;
        }

        // Debounce the chart data fetch to prevent multiple rapid calls
        const timeoutId = setTimeout(() => {
            fetchChartData()
        }, 300); // 300ms delay

        return () => clearTimeout(timeoutId);
    }, [dateRange, selectedDashboards, showSourcePicker])

    // Table columns for top problems (matching TopProblems component)
    const topProblemsColumns = [
        {
            "title": "ID",
            "dataIndex": "id",
        },
        {
            title: "Area",
            dataIndex: "label",
            key: "label",
            sorter: (a, b) => {
                const labelA = a.label || "No Topic";
                const labelB = b.label || "No Topic";
                return labelA.localeCompare(labelB);
            },
            render: (text, record) => {
                if (!text || text.trim() === '') {
                    return (
                        <span style={{ 
                            color: theme === 'dark' ? '#8c8c8c' : '#999',
                            fontStyle: 'italic' 
                        }}>
                            No Topic
                        </span>
                    );
                }
                
                const displayText = text.replace(/^.\s/, '');
                const emoji = text.match(/^.\s/) ? text.split(' ')[0] : '';
                
                return (
                    <div 
                        style={{ 
                            cursor: 'pointer',
                            padding: '8px',
                            borderRadius: '4px',
                            transition: 'text-decoration 0.2s',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                        onClick={() => handleProblemClick(record)}
                        onMouseEnter={(e) => {
                            e.target.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.textDecoration = 'none';
                        }}
                    >
                        <span style={{ fontWeight: 'bold', color: theme === 'dark' ? '#ffffff' : '#333333' }}>
                            <span className="areaEmoji">{emoji}</span>
                            {displayText}
                        </span>
                        <ArrowUpOutlined 
                            style={{ 
                                color: theme === 'dark' ? '#8c8c8c' : '#666',
                                fontSize: '12px',
                                marginLeft: '4px',
                                transform: 'rotate(45deg)'
                            }} 
                        />
                    </div>
                );
            },
        },
        {
            title: "Root Cause",
            dataIndex: "root_cause",
            key: "root_cause",
            sorter: (a, b) => a.root_cause.localeCompare(b.root_cause),
            render: (text, record) => {
                return (
                    <div 
                        style={{ 
                            cursor: 'pointer',
                            padding: '8px',
                            borderRadius: '4px',
                            transition: 'text-decoration 0.2s',
                            position: 'relative'
                        }}
                        onClick={() => handleProblemClick(record)}
                        onMouseEnter={(e) => {
                            e.target.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.textDecoration = 'none';
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                            <span style={{ 
                                whiteSpace: 'normal', 
                                wordBreak: 'break-word', 
                                flex: 1,
                                color: theme === 'dark' ? '#d9d9d9' : '#666666'
                            }}>
                                {text}
                                <ArrowUpOutlined 
                                    style={{ 
                                        color: theme === 'dark' ? '#8c8c8c' : '#666',
                                        fontSize: '12px',
                                        marginLeft: '4px',
                                        transform: 'rotate(45deg)'
                                    }} 
                                />
                            </span>
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Recommendation",
            dataIndex: "recommendation",
            key: "recommendation",
            sorter: (a, b) => a.recommendation.localeCompare(b.recommendation),
            render: (text) => (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                    <span style={{ 
                        whiteSpace: 'normal', 
                        wordBreak: 'break-word', 
                        flex: 1,
                        color: theme === 'dark' ? '#d9d9d9' : '#666666'
                    }}>
                        {text}
                    </span>
                </div>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sorter: (a, b) => {
                if (a.status === b.status) return 0;
                return a.status ? 1 : -1;
            },
            width: 250,
            render: (status) => {
                const statusConfig = {
                    planning: { color: '#faad14', text: 'Planning to take action' },
                    completed: { color: '#52c41a', text: 'Action taken' },
                    no_action: { color: '#ff4d4f', text: 'No action needed' }
                };
                const config = statusConfig[status] || { color: '#d9d9d9', text: status };
                
                return (
                    <Tag color={config.color} style={{ fontWeight: 'bold' }}>
                        {config.text}
                    </Tag>
                );
            },
        },
        {
            title: "Updated By",
            key: "updated_by",
            width: 120,
            sorter: (a, b) => (a.updated_by || 0) - (b.updated_by || 0),
            render: (_, record) => {
                return (
                    <span style={{ 
                        fontSize: '12px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'inline-block',
                        width: '100px',
                        maxWidth: '100px',
                        color: theme === 'dark' ? '#d9d9d9' : '#666666'
                    }}>
                        {record?.updated_by || ""}
                    </span>
                );
            },
        },
    ];


    if (authenticated === "logged" && !subscriptionHydrated) {
        return (
            <div className={styles.mainWindow}>
                <div className={styles.cjLockedSpinner}>
                    <Spin size="large" spinning />
                </div>
            </div>
        );
    }

    if (
        authenticated === "logged" &&
        subscriptionHydrated &&
        !canAccessCustomerJourney
    ) {
        return (
            <div
                className={`${styles.mainWindow} ${styles.cjLockedPage} ${
                    theme === "dark" ? styles.cjLockedPageDark : styles.cjLockedPageLight
                }`}
            >
                <div className={styles.cjBackground}>
                    <div className={styles.cjGrid} />
                    <div className={styles.cjOrbOne} />
                    <div className={styles.cjOrbTwo} />
                    <div className={styles.cjGhostChart}>
                        <span className={styles.cjGhostChartLabel}>Net Sentiment Score</span>
                        <div className={styles.cjGhostBars}>
                            <i style={{ height: "38%" }} />
                            <i style={{ height: "64%" }} />
                            <i style={{ height: "48%" }} />
                            <i style={{ height: "82%" }} />
                            <i style={{ height: "56%" }} />
                            <i style={{ height: "72%" }} />
                        </div>
                    </div>
                    <div className={styles.cjGhostSteps}>
                        <span>Awareness</span>
                        <span>Booking</span>
                        <span>Stay</span>
                        <span>Post-stay</span>
                    </div>
                </div>
                <div className={styles.cjLockedModal}>
                    <div className={styles.cjLockedIcon}>
                        <NodeIndexOutlined />
                    </div>
                    <p className={styles.cjLockedEyebrow}>
                        {t("customer_journey_lock.eyebrow")}
                    </p>
                    <h1>{t("customer_journey_lock.heading")}</h1>
                    <p className={styles.cjLockedText}>
                        {t("customer_journey_lock.body")}
                    </p>
                    <div className={styles.cjLockedActions}>
                        <Button
                            type="primary"
                            size="large"
                            icon={<MailOutlined />}
                            href="mailto:hello@pivony.com?subject=Customer%20Journey%20Add-on"
                            className={styles.cjLockedCtaPrimary}
                            onClick={() =>
                                trackAddonLockCtaClicked("customer_journey", "email")
                            }
                        >
                            {t("product_lock.talk_to_sales")}
                        </Button>
                        <Button
                            size="large"
                            icon={<LinkOutlined />}
                            href={CUSTOMER_JOURNEY_PRODUCT_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.cjLockedCtaSecondary}
                            onClick={() =>
                                trackAddonLockCtaClicked("customer_journey", "read_more")
                            }
                        >
                            {t("product_lock.upgrade_demo")}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.mainWindow}>
            {/* Always visible title and subtitle */}
            <div className={styles.heroSection}>
                <div className={styles.heroContent}>
                    <div className={styles.text}>
                        <h5>{t("customer_journey.1")}</h5>
                        <h6>{t("customer_journey.2")}</h6>
                    </div>
                </div>
            </div>

            {/* Show loading screen while initializing */}
            {isInitializing || cjConfigured === null ? (
                <></>
            ) : (
                <>
                    {/* If the journey has never been mapped, show the setup wizard.
                        Otherwise show the chart with an Edit entry point. */}
                    {!cjConfigured ? (
                <div className={styles.modernSourcePicker}>
                    <JourneySettings
                        theme={theme}
                        mode="wizard"
                        dashboards={dashboards}
                        selectedDashboards={selectedDashboards}
                        onDashboardsChange={handleWizardDashboardsChange}
                        onSaved={handleSettingsSaved}
                    />
                </div>
            ) : (
                <div className={styles.dashboardView}>
                    <div className={styles.header}>
                        <div className={styles.content}>
                            {showDateFilterPopup && (
                                <div ref={dateFilterRef}>
                            <DateFilterPopUp
                                        onChange={(dateString, daysRange) => {
                                        // Handle all time case (empty array) and regular date ranges
                                        if (daysRange === 'allTime' || !dateString || dateString.length === 0) {
                                            setDateRange([]) // Empty array for all time
                                        } else {
                                            // Convert string dates back to dayjs objects
                                            const dayjsDates = dateString.map(dateStr => dayjs(dateStr))
                                            setDateRange(dayjsDates)
                                        }
                                        setShowDateFilterPopup(false)
                                        setSelectedDaysRange(daysRange)
                                        }}
                                close={() => {
                                    setShowDateFilterPopup(false)
                                }}
                                selectedDaysRange={selectedDaysRange}
                                defaultStartDate={new Date()}
                                defaultEndDate={new Date()}
                                searchPeriod={[new Date(), new Date()]}
                            />
                        </div>
                            )}
            </div>
            <div className={styles.buttonWrapper}>
                        <Select
                            mode="multiple"
                            value={selectedDashboards}
                            allowClear
                            suffixIcon={null}
                            onDropdownVisibleChange={(val) => {
                                if (val == false) {
                                    saveSelects()
                                }
                            }}
                            onClear={() => {
                                saveSelects()
                            }}
                            onDeselect={(val) => {
                                saveSelects(val)
                            }}
                            style={{ width: "300px" }}
                            placeholder={<div className={styles.placeholder}> Please select dashboards</div>}
                            onChange={(value) => {
                                setSelectedDashboards(value)
                            }}
                        >
                                    {dashboards && dashboards.length ? dashboards.map((info) => {
                                    return <Select.Option value={info.id} key={info.id}>{info.name}</Select.Option>;
                                    }) : ""}
                                </Select>

                <button
                    className={styles.dateFilterPopupBtn}
                    onClick={() => setShowDateFilterPopup(!showDateFilterPopup)}
                >
                    <img
                                    src={theme === "dark" ? "/assets/calendar.svg" : "/assets/calendar_black.svg"}
                        alt=""
                    />
                    {selectedDaysRange === 'custom' ? `${dayjs(dateRange[0]).format("MMMM D, YYYY")} - ${dayjs(dateRange[1]).format("MMMM D, YYYY")}`:
                    rangePresets[`${selectedDaysRange}`].label}
                    <img
                                    src={theme === "dark" ? "/assets/arrow_down.svg" : "/assets/arrow_down_black.svg"}
                        alt=""
                    />
                </button>

                <Button
                    icon={<SettingOutlined />}
                    onClick={() => setShowSettings(true)}
                >
                    {t("customer_journey.cj_settings.edit_button")}
                </Button>
            </div>
        </div>


   

                    {/* Net Sentiment Score Title Section */}
                    <div className={styles.chartTitleSection}>
                        <div className={styles.chartTitleContainer}>
                            <span className={styles.chartTitle}>
                                <span>Net Sentiment Score</span>
                                <Tooltip
                                    title="Net Sentiment Score is calculated as the difference between positive and negative sentiment percentages. A positive score indicates more positive sentiment, while a negative score indicates more negative sentiment."
                                    color="#100D31"
                                    placement="top"
                                >
                                    <img
                                        className={styles.infoIcon}
                                        src={
                                            theme === "dark"
                                                ? "/assets/info1.svg"
                                                : "/assets/info1_black.svg"
                                        }
                                        alt="Info"
                                    />
                                </Tooltip>
                            </span>
                        </div>
                    </div>

                    <div className={chartData && Object.keys(chartData).length > 0 ? styles.chart : styles.chartEmpty}>
                    <Spin
            className={styles.customSpin}
            spinning={loading}
        >
                        {/* <BarChart ChartData={chartData} /> */}
                        <BarChart ChartData={chartData} theme={theme} onBarClick={handleBarClick}/>
                        </Spin>
                    </div>

    
        
                </div>
                    )}
                </>
            )}

            {/* Side Panel Drawer */}
            <Drawer
                title={selectedBarData ? selectedBarData.brand : "AI Problems Root Cause Analysis & Recommendations"}
                placement="right"
                closable
                onClose={handleCloseSidePanel}
                open={sidePanelOpen}
                width={650}
                closeIcon={<CloseOutlined style={{ color: theme === 'dark' ? 'white' : 'black' }} />}
                styles={{
                    body: { padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }
                }}
            >
                <div className={styles.sidePanelContainer}>
                    <Tabs
                        activeKey={sidePanelTab}
                        onChange={handleSidePanelTabChange}
                        className={styles.sidePanelTabs}
                        items={[
                            {
                                key: "insights",
                                label: t(
                                    "customer_journey.side_panel.insights_tab",
                                    "Root Cause Insights"
                                ),
                                children: (
                                    <div className={styles.problemsSection}>
                                        <div className={styles.problemsHeader}>
                                            <div className={styles.problemsIcon}>
                                                ?
                                            </div>
                                            <h3 className={styles.problemsTitle}>
                                                AI Problems Root Cause Analysis & Recommendations
                                            </h3>
                                        </div>

                                        <p className={styles.problemsDescription}>
                                            {t(
                                                "customer_journey.side_panel.insights_hint",
                                                "Click a root cause to open associated reviews"
                                            )}
                                        </p>

                                        <div className={styles.problemsTableContainer}>
                                            <Table
                                                dataSource={topProblems}
                                                columns={[
                                                    {
                                                        title: "Area",
                                                        dataIndex: "label",
                                                        key: "label",
                                                        width: 100,
                                                        render: (text) => (
                                                            <span className={styles.areaCell}>
                                                                {text || "General"}
                                                            </span>
                                                        ),
                                                    },
                                                    {
                                                        title: "Root Cause",
                                                        dataIndex: "root_cause",
                                                        key: "root_cause",
                                                        width: 180,
                                                        render: (text, record) => {
                                                            const isSelected =
                                                                selectedProblem?.rc_id ===
                                                                    record.rc_id ||
                                                                selectedProblem?.id ===
                                                                    record.id;
                                                            return (
                                                                <div
                                                                    className={`${styles.rootCauseCell} ${isSelected ? styles.selected : ""}`}
                                                                    onClick={() =>
                                                                        fetchProblemReviews(
                                                                            record
                                                                        )
                                                                    }
                                                                >
                                                                    {text || record.problem}
                                                                </div>
                                                            );
                                                        },
                                                    },
                                                    {
                                                        title: "Recommendation",
                                                        dataIndex: "recommendation",
                                                        key: "recommendation",
                                                        width: 180,
                                                        render: (text) => (
                                                            <span
                                                                className={
                                                                    styles.recommendationCell
                                                                }
                                                            >
                                                                {text ||
                                                                    "No recommendation available"}
                                                            </span>
                                                        ),
                                                    },
                                                ]}
                                                loading={topProblemsLoading}
                                                rowKey={(record, index) =>
                                                    record.rc_id || record.id || index
                                                }
                                                pagination={false}
                                                scroll={{ x: 400, y: "calc(100vh - 280px)" }}
                                                size="small"
                                                bordered={false}
                                                style={{ fontSize: "11px" }}
                                                locale={{
                                                    emptyText: t("common.no_data", "No data"),
                                                }}
                                                onRow={(record) => ({
                                                    style: {
                                                        background:
                                                            selectedProblem?.rc_id ===
                                                                record.rc_id ||
                                                            selectedProblem?.id === record.id
                                                                ? `rgba(99, 102, 241, 0.1)`
                                                                : "transparent",
                                                        borderLeft:
                                                            selectedProblem?.rc_id ===
                                                                record.rc_id ||
                                                            selectedProblem?.id === record.id
                                                                ? `3px solid var(--active)`
                                                                : "3px solid transparent",
                                                        transition: "all 0.2s ease",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>
                                ),
                            },
                            {
                                key: "reviews",
                                label: t(
                                    "customer_journey.side_panel.reviews_tab",
                                    "Associated Reviews"
                                ),
                                children: (
                                    <div className={styles.reviewsSection}>
                                        <div className={styles.reviewsHeader}>
                                            <h4 className={styles.reviewsTitle}>
                                                {selectedProblem
                                                    ? `${t(
                                                          "customer_journey.side_panel.reviews_for",
                                                          "Reviews"
                                                      )} — ${
                                                          selectedProblem?.root_cause ||
                                                          selectedProblem?.problem ||
                                                          selectedProblem?.label ||
                                                          ""
                                                      }`
                                                    : t(
                                                          "customer_journey.side_panel.step_reviews",
                                                          "All reviews for this step"
                                                      )}
                                            </h4>
                                        </div>

                                        <div className={styles.reviewsContent}>
                                            <div className={styles.reviewsListWrapper}>
                                                <Spin spinning={reviewsLoading}>
                                                    {problemReviews &&
                                                    problemReviews.length > 0 ? (
                                                        <WelcomeDrawerReviewsList
                                                            allReviews={problemReviews}
                                                            reviewsLoading={reviewsLoading}
                                                            showTotalCount
                                                            theme={theme}
                                                        />
                                                    ) : (
                                                        <div
                                                            className={
                                                                styles.noReviewsMessage
                                                            }
                                                        >
                                                            {reviewsLoading
                                                                ? t(
                                                                      "common.loading",
                                                                      "Loading..."
                                                                  )
                                                                : selectedProblem
                                                                  ? t(
                                                                        "customer_journey.side_panel.no_reviews",
                                                                        "No reviews found for this problem."
                                                                    )
                                                                  : t(
                                                                        "customer_journey.side_panel.no_step_reviews",
                                                                        "No reviews found for this step."
                                                                    )}
                                                        </div>
                                                    )}
                                                </Spin>
                                            </div>
                                        </div>
                                    </div>
                                ),
                            },
                        ]}
                    />
                </div>
            </Drawer>

            {/* Journey structure / topic mapping editor */}
            <Drawer
                title={t("customer_journey.cj_settings.edit_title")}
                placement="right"
                closable
                onClose={() => setShowSettings(false)}
                open={showSettings}
                width={720}
                closeIcon={<CloseOutlined style={{ color: theme === 'dark' ? 'white' : 'black' }} />}
                destroyOnClose
            >
                {showSettings && (
                    <JourneySettings
                        theme={theme}
                        mode="edit"
                        onSaved={handleSettingsSaved}
                        onCancel={() => setShowSettings(false)}
                    />
                )}
            </Drawer>
    </div>
    );
}

export default CustomerJourney